export default { sha: 'd8905dc41c7b53057e84601cd111fe656c27ba42', buildNumber: 'undefined' }
